import { defineStore } from "pinia";
import axios from "axios";
import { useToast } from 'vue-toastification';
const toast = useToast();

export const useForgetStore = defineStore("forget", {
    state: () => {
        return {
            loadings: false
        };
    },

    getters: {
        loading: (state) => state.loadings,
    },

    actions: {
        post(data) {
            this.loadings = true;
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'forgetpassword',
                data: {
                    ...data
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        toast.error(error.response.data.msg);
                        reject(error.response.data.msg);
                    });
            });
        },
        confrim(data) {
            this.loadings = true;
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'forgetpassword/confirm',
                data: {
                    ...data
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        toast.error(error.response.data.msg);
                        reject(error.response.data.msg);
                    });
            });
        }
    },
});